import { Component, Input, OnInit } from '@angular/core';
import { UsersService } from '../../../injections/users.service';
import { UserService } from '../../../injections/user.service';
import { SettingsService } from '../../../injections/settings.service';
import { ServiceService } from '../../../injections/service.service';
import {Router, ActivatedRoute} from "@angular/router";

@Component({
  templateUrl: '../templates/main-newService.html'
})
export class MainNewServiceComponent implements OnInit{
   
    public selectedOffice: boolean = false;
    public enableCreateService = false;
    public enableButtonCreateService = false;
    public selectedAddress = null;
    public user = [];
    public service;
    public settings = {};
    constructor(
        private usersService: UsersService, 
        private serviceService: ServiceService, 
        private router: Router, private aRoute: ActivatedRoute,
        private settingsService: SettingsService
    ){
        this.settingsService.getComissions().subscribe(result => {
            this.settings["comissions"] = result;
        }); 
    }

    public showUserData(value: any){
        var id;
        (typeof value === 'string') ? id = value : id = value["id"];
        this.usersService.getUserById(id).subscribe(result => {
            this.enableCreateService = true;
            this.user = result;
            this.user["cleaner_preference"] = (this.user["cleaner_preference"] == 0) ? "Enviar otra cleaner por defecto" : "Ponerse en contacto con el usuario";
            this.user["contact_preference"] = this.getContactMethod(this.user["contact_preference"]);
            this.settings["mango_card_id"] = result["mango_card_id"];
        });   
    }

    public showCreateService(event: any){
        this.selectedAddress = event;
        this.settingsService.getTransportPrice(this.selectedAddress["zip_code"]).subscribe(result => {
             this.settings["transport"] = result;
        });

        this.settingsService.getProductsPrice().subscribe(result => {
            this.settings["products"] = result.toFixed(2);
        });
    }

    public validateCreateService(event){
        this.service = event.data;
        this.enableButtonCreateService =  (event["valid"]) ? true : false;
    }

    public createService(){
        this.parseDataToSend();
        this.enableButtonCreateService = false;
        this.serviceService.createService(this.service).subscribe(
            result => {
            this.enableButtonCreateService = true;
            this.router.navigate(['/services', result["serviceId"]]);
            },
            error => {
                console.log(error);
            }
        );
    }

    private getContactMethod(value){
        let method;
        if(value == 0) method = "Email";
        else if(value == 1) method = "Teléfono";
        else if(value == 2) method = "Whatsapp";
  
        return method;
    }

    private parseDataToSend() {
        
        this.service["addressId"] = this.selectedAddress["id_address"];
        this.service["postalCode"] = this.selectedAddress["zip_code"];
        this.service["idClintuOffice"] = this.selectedAddress["id_clintu_office"].toString();
        this.service["id_available_city"] =  parseInt(this.selectedAddress["id_available_city"]);
        
        this.service["address"] = {
            id: this.selectedAddress["id_address"],
            address: this.selectedAddress["address"],
            number: this.selectedAddress["number"],
            floor: this.selectedAddress["floor"],
            door: this.selectedAddress["door"],
            city: this.selectedAddress["city"],
            province: this.selectedAddress["province"],
            provinceName: "",
            country: this.selectedAddress["country"],
            availableCity: this.selectedAddress["id_available_city"],
            postalCode: this.selectedAddress["zip_code"],
            //id_available_city: this.selectedAddress["id_available_city"].toString()
        }
        this.service["user"] = {
            id: this.user["id_client"],
            name: this.user["name"],
            surname: this.user["surname"],
            email: this.user["email"],
            phone: this.user["phone"],
            language: this.user["language"],
            password: ""
        }
        
        this.service["paymentInfo"] = {
            new: false
        }
    }

    ngOnInit() {}

    
}


// WEBPACK FOOTER //
// ./src/app/modules/services/components/main-newService.component.ts